import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import {ConfigService} from './config.service';
import {Observable, throwError} from 'rxjs';
// @ts-ignore
const token = JSON.parse(localStorage.getItem('tokenCurrentConnected'));
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + token
  }),
};

@Injectable({
  providedIn: 'root'
})
export class SubCertificationService {

  constructor(private http: HttpClient, private config: ConfigService) { }
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
  private extractData(res: Response) {
    const body = res;
    return body || { };
  }

  getSousCertificat(): Observable<any> {
    return this.http.get(this.config.urlDEV + '/souscertificats', httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }
  getOneSousCertificat(id): Observable<any> {
    return this.http.get(this.config.urlDEV + '/souscertificats/' + id, httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }
  getListSiteForSubCErt(id): Observable<any> {
    return this.http.get(this.config.urlDEV + '/get_list_site_sous_certification/' + id, httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }
  getListVerificationForSubCErt(id): Observable<any> {
    return this.http.get(this.config.urlDEV + '/get_list_verifications_sous_certification/' + id, httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }
  updateSousCertificat(data) {
    return this.http.post(this.config.urlDEV + '/upd_souscertificats', data, httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

  deleteSousCertificat(data) {
    return this.http.post(this.config.urlDEV + '/del_souscertificats', data, httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }
  getSubCertificatBySiteUser(user_id): Observable<any> {
    return this.http.get(this.config.urlDEV + '/souscertificats/user/' + user_id, httpOptions).pipe(
      map(this.extractData),
      catchError(this.handleError));
  }

}
